module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_9016.851d821d.png";